export const getOrgChannel = (orgType: number) => {
  return orgType > 0 ? 'testH1' : 'testG1';
};

export const delay = (time: number) => {
  return new Promise((r) => setTimeout(r, time));
};
